import axios from 'axios';

const BASE_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs';
const TOKEN = 'caf0c901861068e390fc66169162371ffb99a4c6';

const APIDadataService = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Token ${TOKEN}`,
  },
});

export default APIDadataService;
